export default "__VITE_ASSET__CclCdnAF__"